import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import { faPrint, FaIcon } from '@/lib/fa'

type AddActivityFooterProps = {
  printAfterSave: boolean
  setPrintAfterSave: (value: boolean) => void
}

const AddActivityFooter = ({
  printAfterSave,
  setPrintAfterSave,
}: AddActivityFooterProps) => {
  const { t } = useLocalize()
  const loading = useLoadingStore(selectLoading)
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-base-300 tw-p-4">
      <label className="tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-content-base">
        <input
          type="checkbox"
          checked={printAfterSave}
          onChange={(e) => setPrintAfterSave(e.target.checked)}
          disabled={loading}
          className="tw-h-4 tw-w-4 tw-cursor-pointer tw-accent-primary"
        />
        <FaIcon icon={faPrint} className="tw-h-4 tw-w-4" />
        {t('activities.print-after-save')}
      </label>
      <button
        disabled={loading}
        type="submit"
        className="tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80"
      >
        {t('operation.confirm')}
      </button>
    </div>
  )
}

export default AddActivityFooter
